import React, { createContext, useContext, useMemo } from 'react';
import { IUserPreferenceStore, useUserPreference } from '../hooks/useUserPreference';
import {
  DisplaySize,
  applyDisplaySize,
  readStoredDisplaySize,
  storeDisplaySize,
} from '../utils/displaySize';

interface IDisplaySizeContext {
  displaySize: DisplaySize;
  setDisplaySize: (size: DisplaySize) => void;
}

const DISPLAY_SIZE_PREFERENCE: IUserPreferenceStore<DisplaySize> = {
  read: readStoredDisplaySize,
  store: storeDisplaySize,
  apply: applyDisplaySize,
};

const DisplaySizeContext = createContext<IDisplaySizeContext | undefined>(undefined);

export const DisplaySizeProvider = ({ children }: { children: React.ReactNode }) => {
  const [displaySize, setDisplaySize] = useUserPreference(DISPLAY_SIZE_PREFERENCE);

  const value = useMemo(() => ({ displaySize, setDisplaySize }), [displaySize, setDisplaySize]);

  return <DisplaySizeContext.Provider value={value}>{children}</DisplaySizeContext.Provider>;
};

export const useDisplaySize = (): IDisplaySizeContext => {
  const context = useContext(DisplaySizeContext);
  if (!context) {
    throw new Error('useDisplaySize must be used within a DisplaySizeProvider');
  }
  return context;
};
